export default __webpack_public_path__ + "static/media/41t.6b96c9ce.jpg";